import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { BiMath } from "../libs/BiMath";

export class CmpInputIndex extends com.CmpInputIndexBase {

    private _onChangeValue:gs.EventGS<string>;
    private _onChangeValueToken:gs.EventGSToken<string>;

    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<string>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        let cacheValue = "";
        this.ctrls.iValue.el.addEventListener('input',async ()=>{
            let value = this._clearValueFunc(this.ctrls.iValue.value);
            if (value===false) {this.ctrls.iValue.value = cacheValue; return;}
            cacheValue = value;
            if (BiMath.isValidAddress(cacheValue))
                this._onChangeValueToken.invoke(cacheValue);
        });
    }

    public getIndex() { 
        let v = this.ctrls.iValue.value; 
        if (v==='') return undefined;
        let index = parseFloat(v);
        if (!index) return 0;
        return index/100;
    }

    public get onChangeValue() {return this._onChangeValue;}

    // public setToken(symbol:string, address:string)
    // {
    //     this.ctrls.lAddressName.text = symbol;
    //     this.ctrls.imgIcon.src="files/images/erc20/"+address.toLowerCase()+".webp";
    //     this.ctrls.iValue.value=address;
    // }

    private _clearValueFunc(value: string) {
        if (value === "") return value;
        if (value.charAt(0) === ".") value = "0" + value;
        const regex = /^[0-9]+(\.[0-9]{0,3})?$/;
        if (!regex.test(value)) return false;
        const num = Number(value);
        if (isNaN(num) || num > 100) return false;
        return value;
    }

}